import { connect } from 'react-redux';
import RecordingView from './RecordingView';
import {
    stopRecording,
    startRecording,
    setRecordingError,
    setRecordingStream,
} from './recordingActions';
import selectors from '../../rootSelectors';

const mapStateToProps = state => ({
    recordingStream: selectors.getRecordingStream(state),
});

const mapDispatchToProps = dispatch => ({
    startRecording: () => dispatch(startRecording()),
    stopRecording: () => dispatch(stopRecording()),
    setRecordingError: recordingError => dispatch(setRecordingError(recordingError)),
    setRecordingStream: recordingStream => dispatch(setRecordingStream(recordingStream)),
});

const RecordingContainer = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    RecordingView,
);

export default RecordingContainer;
